'use client';

import { c as _c } from "react/compiler-runtime";
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useEffect, useRef, useState, type RefObject } from 'react';
import { useHover } from 'usehooks-ts';
import { ScrollArrow } from '@/components/ScrollEdge';
import { Carousel, CarouselContent, CarouselItem, type CarouselApi } from '@/components/ui/carousel';
import ViverseWorldCard from '@/components/ViverseWorldCard';
import type { getPromotionBannerData } from '@/server/lib/banner';
import HeroBannerCarouselDots from '@/app/[locale]/(worlds)/components/HeroBannerCarouselDots';
type HeroBannerPromoProps = {
  bannerData: Awaited<ReturnType<typeof getPromotionBannerData>>;
  liveRoomIds: string[];
};
export default function HeroBannerPromo(t0) {
  const $ = _c(30);
  const {
    bannerData,
    liveRoomIds
  } = t0;
  const slides = bannerData.activityShowcases.filter(_temp);
  const [api, setApi] = useState();
  const [current, setCurrent] = useState(0);
  const hoverRef = useRef(null) as RefObject<HTMLDivElement>;
  const isHovered = useHover(hoverRef);
  let t1;
  let t2;
  if ($[0] !== api) {
    t1 = () => {
      if (!api) {
        return;
      }
      setCurrent(api.selectedScrollSnap());
      const handler = () => setCurrent(api.selectedScrollSnap());
      api.on("select", handler);
      return () => {
        api.off("select", handler);
      };
    };
    t2 = [api];
    $[0] = api;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const hasMultiple = slides.length > 1;
  const t3 = "hero-banner-promo";
  const t4 = "flex shrink-0 flex-col gap-4 lg:w-[430px]";
  const t5 = "relative";
  const T0 = Carousel;
  let t6;
  if ($[3] !== hasMultiple) {
    t6 = {
      loop: hasMultiple,
      duration: 0
    };
    $[3] = hasMultiple;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const t7 = "w-full";
  const T1 = CarouselContent;
  const t8 = "-ml-2";
  let t9;
  if ($[5] !== isHovered || $[6] !== liveRoomIds) {
    t9 = (item_0, index) => <CarouselItem key={index} className="pl-2"><ViverseWorldCard cardType="banner" className="cursor-grab active:cursor-grabbing" info={{
        title: item_0.title,
        image: item_0.background || item_0.video?.image
      }} isLive={liveRoomIds.some(id => item_0.action_link?.includes(id))} banner={{
        description: item_0.description,
        ctaHref: item_0.action_link,
        ctaLabel: item_0.action_title,
        ctaHref2: item_0.action_link_2,
        ctaLabel2: item_0.action_title_2,
        isHovered
      }} priority={index === 0} /></CarouselItem>;
    $[5] = isHovered;
    $[6] = liveRoomIds;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  const t10 = slides.map(t9);
  let t11;
  if ($[8] !== T1 || $[9] !== t10) {
    t11 = <T1 className={t8}>{t10}</T1>;
    $[8] = T1;
    $[9] = t10;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  if ($[11] !== T0 || $[12] !== setApi || $[13] !== t11 || $[14] !== t6) {
    t12 = <T0 opts={t6} setApi={setApi} className={t7}>{t11}</T0>;
    $[11] = T0;
    $[12] = setApi;
    $[13] = t11;
    $[14] = t6;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== api || $[17] !== hasMultiple || $[18] !== isHovered) {
    t13 = hasMultiple && <><ScrollArrow side="left" visible={isHovered} onClick={() => api?.scrollPrev()} icon={<ChevronLeft className="stroke-background size-4" />} className="w-auto md:left-4 lg:left-4" buttonClassName="size-8" /><ScrollArrow side="right" visible={isHovered} onClick={() => api?.scrollNext()} icon={<ChevronRight className="stroke-background size-4" />} className="w-auto md:right-4 lg:right-4" buttonClassName="size-8" /></>;
    $[16] = api;
    $[17] = hasMultiple;
    $[18] = isHovered;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t12 || $[21] !== t13) {
    t14 = <div ref={hoverRef} className={t5}>{t12}{t13}</div>;
    $[20] = t12;
    $[21] = t13;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== current || $[24] !== hasMultiple || $[25] !== slides) {
    t15 = hasMultiple && <HeroBannerCarouselDots count={slides.length} current={current} showShadow={false} />;
    $[23] = current;
    $[24] = hasMultiple;
    $[25] = slides;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t14 || $[28] !== t15) {
    t16 = <div data-section={t3} className={t4}>{t14}{t15}</div>;
    $[27] = t14;
    $[28] = t15;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  return t16;
}
function _temp(item) {
  return item.action_link;
}